export const subpagesTranslations = {
    en: {
        dubrovnik: {
            header: "DUBROVNIK BY BOAT",
            title: "THE PEARL OF THE MEDITERRANEAN",
            firstP: "On the way to",
            linkP: "Dubrovnik",
            secondP: "we sail through the waters of the Elaphite Islands and the Dubrovnik Reefs. The ride, which takes about one hour and forty-five minutes, ends with a trip to the historic old town, and its famous port called Porat. When sailing into the city, we sail around the walls of the city, which offers an unforgettable panoramic experience.",
            thirdP: "This is an opportunity to get a full experience of Dubrovnik's specificity and to visit the city from land and sea.",
            fifthP: "Don't miss this unique opportunity.",
            infoFirstP: "in",
            infoFirstPBold: "OLD TOWN",
            infoArrivalTimeP: "16:45",
            price: "45€",
        },
        elaphiti: {
            header: "ELAPHITE ISLANDS CRUISE",
            title: "UNIQUE ISLANDS OF CROATIA",
            firstP: "On this excursion, we will visit two of the most beautiful islands in the archipelago of the Elaphite Islands, the islands of",
            linkP: "Lopud",
            and: " and ",
            secondLinkP: "Šipan",
            secondP: "and visit their historic old settlements. During the voyage, you can see the unspoiled beauty of the coast, which incurred as a result of tectonic shifts during the creation of islands and the influence of the sea. The view of the bays, slopes, gorges, caves and rocks is what makes this excursion unique, as well as the view of the open sea.",
            thirdP: "The highlight of the trip is to swim from an anchored boat in one of these beautiful bays.",
            fourthP: "You will also enjoy eating freshly made risotto frutti di mare served with chilled white wine, refreshing water and smile.",
            infoFirstP: "on island",
            infoFirstPBold: "Lopud",
            infoSecondPBold: "45 minutes ",
            infoSecondP: "free time on island",
            infoSecondPSecondBold: "Šipan",
            infoThirdP: "Stop for swimming around anchored boat in one of beautiful bays of island",
            infoThirdPBold: "Jakljan",
            infoArrivalTimeP: "17:00",
            price: "60€",
            infoLunch: " and",
            infoLunchBold: "LUNCH",
            infoLunchSecond: "- our recognizable dalmatian seafood risotto",
            infoVegeLunch: "*vegetarian lunch option is available",
        }
    },
    hr: {
        dubrovnik: {
            header: "DUBROVNIK BRODOM",
            title: "BISER MEDITERANA",
            firstP: "Na putu prema",
            linkP: "Dubrovniku",
            secondP: "jedrimo kroz vode Elafitskih otoka i Dubrovačkog primorja. Vožnja, koja traje oko sat i četrdeset pet minuta, završava posjetom povijesnom starom gradu i njegovoj poznatoj luci zvanoj Porat. Pri ulasku u grad, obilazimo gradske zidine što pruža nezaboravno panoramsko iskustvo.",
            thirdP: "Ovo je prilika da doživite Dubrovnik u potpunosti i posjetite grad s kopna i mora.",
            fifthP: "Ne propustite ovu jedinstvenu priliku.",
            infoFirstP: "u",
            infoFirstPBold: "STAROM GRADU",
            infoArrivalTimeP: "16:45",
            price: "45€",
        },
        elaphiti: {
            header: "KRSTARENJE ELAFITIMA",
            title: "JEDINSTVENI OTOCI HRVATSKE",
            firstP: "Na ovom izletu posjetit ćemo dva najljepša otoka arhipelaga Elafitskih otoka, otoke",
            linkP: "Lopud",
            and: " i ",
            secondLinkP: "Šipan",
            secondP: "te posjetiti njihova povijesna naselja. Tijekom plovidbe možete vidjeti netaknutu ljepotu obale koja je nastala tektonskim pomacima pri nastanku otoka i utjecajem mora. Pogled na uvale, padine, klisure, špilje i stijene ono je što ovaj izlet čini jedinstvenim, kao i pogled na otvoreno more.",
            thirdP: "Vrhunac izleta je kupanje s usidrenog broda u jednoj od tih prekrasnih uvala.",
            fourthP: "Također ćete uživati u svježe pripremljenom rižotu frutti di mare uz rashlađeno bijelo vino, osvježavajuću vodu i osmijeh.",
            infoFirstP: "na otoku",
            infoFirstPBold: "Lopudu",
            infoSecondPBold: "45 minuta ",
            infoSecondP: "slobodnog vremena na otoku",
            infoSecondPSecondBold: "Šipanu",
            infoThirdP: "Zaustavljanje za kupanje s usidrenog broda u jednoj od lijepih uvala otoka",
            infoThirdPBold: "Jakljana",
            infoArrivalTimeP: "17:00",
            price: "60€",
            infoLunch: " i",
            infoLunchBold: "RUČAK",
            infoLunchSecond: "- naš prepoznatljivi dalmatinski rižoto s plodovima mora",
            infoVegeLunch: "*dostupna vegetarijanska opcija ručka",
        }
    },
    es: {
        dubrovnik: {
            header: "DUBROVNIK EN BARCO",
            title: "LA PERLA DEL MEDITERRÁNEO",
            firstP: "De camino a",
            linkP: "Dubrovnik",
            secondP: "navegamos por las aguas de las islas Eláfites y los arrecifes de Dubrovnik. El trayecto, de aproximadamente una hora y cuarenta y cinco minutos, termina con una visita al histórico casco antiguo y su famoso puerto llamado Porat. Al entrar a la ciudad, rodeamos las murallas, lo que ofrece una experiencia panorámica inolvidable.",
            thirdP: "Esta es una oportunidad para vivir plenamente la experiencia de Dubrovnik y visitar la ciudad desde tierra y mar.",
            fifthP: "¡No pierdas esta oportunidad única!",
            infoFirstP: "en",
            infoFirstPBold: "CIUDAD VIEJA",
            infoArrivalTimeP: "16:45",
            price: "45€",
        },
        elaphiti: {
            header: "CRUCERO ISLAS ELÁFITES",
            title: "ISLAS ÚNICAS DE CROACIA",
            firstP: "En esta excursión visitaremos dos de las islas más bellas del archipiélago de las Islas Eláfites, las islas de",
            linkP: "Lopud",
            and: " y ",
            secondLinkP: "Šipan",
            secondP: "y visitaremos sus históricos asentamientos. Durante el viaje, podrá ver la belleza virgen de la costa, formada por desplazamientos tectónicos y la influencia del mar. La vista de las bahías, laderas, gargantas, cuevas y rocas es lo que hace única esta excursión, así como la vista del mar abierto.",
            thirdP: "El punto culminante del viaje es nadar desde un barco anclado en una de estas hermosas bahías.",
            fourthP: "También disfrutará de un risotto frutti di mare recién preparado con vino blanco frío, agua refrescante y una sonrisa.",
            infoFirstP: "en la isla",
            infoFirstPBold: "Lopud",
            infoSecondPBold: "45 minutos ",
            infoSecondP: "tiempo libre en la isla",
            infoSecondPSecondBold: "Šipan",
            infoThirdP: "Parada para nadar desde el barco anclado en una de las hermosas bahías de la isla",
            infoThirdPBold: "Jakljan",
            infoArrivalTimeP: "17:00",
            price: "60€",
            infoLunch: " y",
            infoLunchBold: "ALMUERZO",
            infoLunchSecond: "- nuestro reconocible risotto dálmata de mariscos",
            infoVegeLunch: "*opción de almuerzo vegetariano disponible",
        }
    },
    it: {
        dubrovnik: {
            header: "DUBROVNIK IN BARCA",
            title: "LA PERLA DEL MEDITERRANEO",
            firstP: "Lungo la strada verso",
            linkP: "Dubrovnik",
            secondP: "navighiamo nelle acque delle Isole Elafiti e delle scogliere di Dubrovnik. Il tragitto, di circa un'ora e quarantacinque minuti, termina con una visita alla storica città vecchia e al suo famoso porto chiamato Porat. Entrando in città, circumnavighiamo le mura, offrendo un'esperienza panoramica indimenticabile.",
            thirdP: "Questa è un'opportunità per vivere appieno l'esperienza di Dubrovnik e visitare la città da terra e dal mare.",
            fifthP: "Non perdere questa opportunità unica.",
            infoFirstP: "nella",
            infoFirstPBold: "CITTÀ VECCHIA",
            infoArrivalTimeP: "16:45",
            price: "45€",
        },
        elaphiti: {
            header: "CROCIERA ISOLE ELAFITI",
            title: "ISOLE UNICHE DELLA CROAZIA",
            firstP: "In questa escursione visiteremo due delle isole più belle dell'arcipelago delle Isole Elafiti, le isole di",
            linkP: "Lopud",
            and: " e ",
            secondLinkP: "Šipan",
            secondP: "e visiteremo i loro storici insediamenti. Durante il viaggio si può ammirare la bellezza incontaminata della costa, formatasi per spostamenti tettonici e l'influenza del mare. La vista delle baie, pendii, gole, grotte e rocce rende unica questa escursione, così come la vista del mare aperto.",
            thirdP: "Il momento clou del viaggio è nuotare da una barca ancorata in una di queste bellissime baie.",
            fourthP: "Potrete anche gustare un risotto frutti di mare appena preparato con vino bianco fresco, acqua rinfrescante e un sorriso.",
            infoFirstP: "sull'isola",
            infoFirstPBold: "Lopud",
            infoSecondPBold: "45 minuti ",
            infoSecondP: "tempo libero sull'isola",
            infoSecondPSecondBold: "Šipan",
            infoThirdP: "Sosta per nuotare dalla barca ancorata in una delle belle baie dell'isola",
            infoThirdPBold: "Jakljan",
            infoArrivalTimeP: "17:00",
            price: "60€",
            infoLunch: " e",
            infoLunchBold: "PRANZO",
            infoLunchSecond: "- il nostro inconfondibile risotto dalmata ai frutti di mare",
            infoVegeLunch: "*opzione pranzo vegetariano disponibile",
        }
    },
    pl: {
        dubrovnik: {
            header: "DUBROWNIK ŁODZIĄ",
            title: "PERŁA MORZA ŚRÓDZIEMNEGO",
            firstP: "W drodze do",
            linkP: "Dubrownika",
            secondP: "płyniemy przez wody Wysp Elafiti i raf Dubrownika. Rejs, trwający około godziny i czterdziestu pięciu minut, kończy się wizytą w historycznym starym mieście i jego słynnym portem zwanym Porat. Wpływając do miasta, opływamy mury miejskie, co zapewnia niezapomniane panoramiczne wrażenia.",
            thirdP: "To okazja do pełnego doświadczenia wyjątkowości Dubrownika i odwiedzenia miasta od strony lądu i morza.",
            fifthP: "Nie przegap tej wyjątkowej okazji.",
            infoFirstP: "w",
            infoFirstPBold: "STARYM MIEŚCIE",
            infoArrivalTimeP: "16:45",
            price: "45€",
        },
        elaphiti: {
            header: "REJS PO WYSPACH ELAFITI",
            title: "WYJĄTKOWE WYSPY CHORWACJI",
            firstP: "Podczas tej wycieczki odwiedzimy dwie najpiękniejsze wyspy archipelagu Wysp Elafiti, wyspy",
            linkP: "Lopud",
            and: " i ",
            secondLinkP: "Šipan",
            secondP: "oraz odwiedzimy ich historyczne osady. Podczas rejsu można podziwiać nieskażone piękno wybrzeża, powstałego w wyniku przesunięć tektonicznych i wpływu morza. Widok zatok, zboczy, wąwozów, jaskiń i skał sprawia, że ta wycieczka jest wyjątkowa, podobnie jak widok otwartego morza.",
            thirdP: "Kulminacją wycieczki jest pływanie z zakotwiczonej łodzi w jednej z tych pięknych zatok.",
            fourthP: "Będziecie mogli również cieszyć się świeżo przygotowanym risotto frutti di mare podawanym ze schłodzonym białym winem, orzeźwiającą wodą i uśmiechem.",
            infoFirstP: "na wyspie",
            infoFirstPBold: "Lopud",
            infoSecondPBold: "45 minut ",
            infoSecondP: "wolnego czasu na wyspie",
            infoSecondPSecondBold: "Šipan",
            infoThirdP: "Postój na pływanie z zakotwiczonej łodzi w jednej z pięknych zatok wyspy",
            infoThirdPBold: "Jakljan",
            infoArrivalTimeP: "17:00",
            price: "60€",
            infoLunch: " i",
            infoLunchBold: "OBIAD",
            infoLunchSecond: "- nasze rozpoznawalne dalmatyńskie risotto z owocami morza",
            infoVegeLunch: "*dostępna opcja obiadu wegetariańskiego",
        }
    },
    fr: {
        dubrovnik: {
            header: "DUBROVNIK EN BATEAU",
            title: "LA PERLE DE LA MÉDITERRANÉE",
            firstP: "En chemin vers",
            linkP: "Dubrovnik",
            secondP: "nous naviguons dans les eaux des îles Élaphites et des récifs de Dubrovnik. Le trajet, d'environ une heure et quarante-cinq minutes, se termine par une visite de la vieille ville historique et de son célèbre port appelé Porat. En entrant dans la ville, nous longeons les remparts, offrant une expérience panoramique inoubliable.",
            thirdP: "C'est l'occasion de vivre pleinement l'expérience de Dubrovnik et de visiter la ville par terre et par mer.",
            fifthP: "Ne manquez pas cette opportunité unique.",
            infoFirstP: "dans la",
            infoFirstPBold: "VIEILLE VILLE",
            infoArrivalTimeP: "16:45",
            price: "45€",
        },
        elaphiti: {
            header: "CROISIÈRE ÎLES ÉLAPHITES",
            title: "ÎLES UNIQUES DE CROATIE",
            firstP: "Lors de cette excursion, nous visiterons deux des plus belles îles de l'archipel des Îles Élaphites, les îles de",
            linkP: "Lopud",
            and: " et ",
            secondLinkP: "Šipan",
            secondP: "et visiterons leurs établissements historiques. Durant le voyage, vous pouvez voir la beauté préservée de la côte, formée par des déplacements tectoniques et l'influence de la mer. La vue des baies, pentes, gorges, grottes et rochers rend cette excursion unique, ainsi que la vue sur la mer ouverte.",
            thirdP: "Le point culminant du voyage est de nager depuis un bateau ancré dans l'une de ces magnifiques baies.",
            fourthP: "Vous pourrez également déguster un risotto frutti di mare fraîchement préparé accompagné de vin blanc frais, d'eau rafraîchissante et d'un sourire.",
            infoFirstP: "sur l'île",
            infoFirstPBold: "Lopud",
            infoSecondPBold: "45 minutes ",
            infoSecondP: "de temps libre sur l'île",
            infoSecondPSecondBold: "Šipan",
            infoThirdP: "Arrêt pour nager depuis le bateau ancré dans l'une des belles baies de l'île",
            infoThirdPBold: "Jakljan",
            infoArrivalTimeP: "17:00",
            price: "60€",
            infoLunch: " et",
            infoLunchBold: "DÉJEUNER",
            infoLunchSecond: "- notre risotto dalmate aux fruits de mer reconnaissable",
            infoVegeLunch: "*option déjeuner végétarien disponible",
        }
    },
    de: {
        dubrovnik: {
            header: "DUBROVNIK PER BOOT",
            title: "DIE PERLE DES MITTELMEERS",
            firstP: "Auf dem Weg nach",
            linkP: "Dubrovnik",
            secondP: "segeln wir durch die Gewässer der Elaphiten-Inseln und der Dubrovniker Riffe. Die Fahrt, die etwa eine Stunde und fünfundvierzig Minuten dauert, endet mit einem Besuch der historischen Altstadt und ihres berühmten Hafens namens Porat. Beim Einfahren in die Stadt umsegeln wir die Stadtmauern, was ein unvergessliches Panoramaerlebnis bietet.",
            thirdP: "Dies ist eine Gelegenheit, Dubrovnik in vollen Zügen zu erleben und die Stadt von Land und See zu besuchen.",
            fifthP: "Verpassen Sie diese einmalige Gelegenheit nicht.",
            infoFirstP: "in der",
            infoFirstPBold: "ALTSTADT",
            infoArrivalTimeP: "16:45",
            price: "45€",
        },
        elaphiti: {
            header: "KREUZFAHRT ELAPHITEN-INSELN",
            title: "EINZIGARTIGE INSELN KROATIENS",
            firstP: "Bei diesem Ausflug besuchen wir zwei der schönsten Inseln des Archipels der Elaphiten-Inseln, die Inseln",
            linkP: "Lopud",
            and: " und ",
            secondLinkP: "Šipan",
            secondP: "und besuchen ihre historischen Siedlungen. Während der Fahrt können Sie die unberührte Schönheit der Küste bewundern, die durch tektonische Verschiebungen und den Einfluss des Meeres entstanden ist. Der Blick auf Buchten, Hänge, Schluchten, Höhlen und Felsen macht diesen Ausflug einzigartig, ebenso wie der Blick auf das offene Meer.",
            thirdP: "Der Höhepunkt der Tour ist das Schwimmen von einem verankerten Boot in einer dieser wunderschönen Buchten.",
            fourthP: "Sie können auch frisch zubereitetes Risotto frutti di mare genießen, serviert mit gekühltem Weißwein, erfrischendem Wasser und einem Lächeln.",
            infoFirstP: "auf der Insel",
            infoFirstPBold: "Lopud",
            infoSecondPBold: "45 Minuten ",
            infoSecondP: "Freizeit auf der Insel",
            infoSecondPSecondBold: "Šipan",
            infoThirdP: "Halt zum Schwimmen vom verankerten Boot in einer der schönen Buchten der Insel",
            infoThirdPBold: "Jakljan",
            infoArrivalTimeP: "17:00",
            price: "60€",
            infoLunch: " und",
            infoLunchBold: "MITTAGESSEN",
            infoLunchSecond: "- unser unverkennbares dalmatinisches Meeresfrüchte-Risotto",
            infoVegeLunch: "*vegetarische Mittagsoption verfügbar",
        }
    }
};